module.exports = __webpack_public_path__ + "img/vip_hover_ed40823.webp";